import React from "react";
import LoginRight from "./LoginRight";

function Login() {
  return (
    <div className="flex min-h-screen flex-col lg:flex-row bg-gray-50">

      {/* LEFT PREMIUM SECTION */}
      <div className="hidden lg:flex lg:w-[55%] relative overflow-hidden h-screen bg-gradient-to-br from-[#005F99] via-[#0078BD] to-[#2f8fdc] text-white px-12 py-12">

        {/* Background glow */}
        <div className="absolute top-[-100px] right-[-100px] w-[300px] h-[300px] bg-[#4da6ff]/30 rounded-full blur-3xl" />
        <div className="absolute bottom-[-120px] left-[-80px] w-[250px] h-[250px] bg-[#0078BD]/20 rounded-full blur-3xl" />

        <div className="absolute top-1/3 right-1/4 w-[400px] h-[400px] bg-white/10 rounded-full blur-3xl pointer-events-none" />


        {/* Building Image */}
        <img
          src="/images/building.png"
          alt="building"
          className="absolute bottom-0 right-0 w-[520px] opacity-10 grayscale pointer-events-none"
        />

        <div className="absolute bottom-0 right-0 w-[600px] h-[350px] bg-gradient-to-t from-[#0078BD]/50 via-[#0078BD]/20 to-transparent pointer-events-none" />

        <div className="relative z-10 w-full max-w-2xl mx-auto flex flex-col justify-center gap-6 py-8">

          {/* TOP CONTENT */}
          <div>
            <div className="mb-6 inline-flex items-center gap-2 px-4 py-1.5 bg-white/10 border border-white/20 rounded-full text-sm">
              ⭐ Trusted by thousands
            </div>

            <h1 className="text-5xl font-semibold leading-[1.1] mb-6 max-w-xl">
              <span className="block text-white/90 font-medium tracking-wide">
                Your partner to
              </span>
              <span className="block text-white mt-2">
                Manage Your{" "} Properties
              </span>
            </h1>

            <p className="text-white/80 text-sm leading-relaxed mb-10 max-w-lg">
              Property management software that helps you list properties,
              manage tenants, collect payments and manage staff - all in one place.
            </p>
          </div>

          {/* BOTTOM CONTENT */}
          <div>
            <div className="grid grid-cols-2 gap-5 mb-10">

              {[
                { title: "Manage Properties", icon: "🏢" },
                { title: "Happy Tenants", icon: "😊" },
                { title: "Track Payments", icon: "💳" },
                { title: "Secure & Reliable", icon: "🔒" },
              ].map((item, i) => (
                <div
                  key={i}
                  className="
                  group flex items-center gap-3
                  px-4 py-3
                  rounded-xl
                  bg-white/10
                  border border-white/20
                  backdrop-blur-md
                  transition-all duration-300
                  hover:bg-white/12 hover:border-white/20
                  hover:shadow-[0_8px_30px_rgba(0,0,0,0.25)]
                "
                >
                  {/* Icon */}
                  <div className="
                    w-8 h-8 flex items-center justify-center
                    rounded-lg
                    bg-white/10
                    text-[#4da6ff]
                    text-sm
                    group-hover:scale-110
                    transition
                  ">
                    {item.icon}
                  </div>

                  {/* Text */}
                  <span className="text-sm font-medium text-white/90 tracking-wide">
                    {item.title}
                  </span>
                </div>
              ))}

            </div>

            {/* Trust line */}
            <div className="flex items-center gap-2 text-xs text-white/70">
              <span className="text-yellow-400">★</span>
              Trusted by <span className="text-white font-medium">5,000+</span> property managers across India
            </div>
          </div>

        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="lg:w-[45%] flex flex-col justify-center bg-white overflow-hidden h-screen">
        <LoginRight />
      </div>
    </div>
  );
}

export default Login;


// import React from "react";
// import {
//   FaBuilding,
//   FaSmile,
//   FaMoneyBillWave,
//   FaShieldAlt,
//   FaRegSmile,
// } from "react-icons/fa";
// import LoginRight from "./LoginRight";
// import { MdOutlineSecurity, MdVerified } from "react-icons/md";
// import { useTranslation } from "react-i18next";
// import { FaMoneyBills } from "react-icons/fa6";
// import { LuBuilding2 } from "react-icons/lu";

// const LoginPage = () => {
//   const { t } = useTranslation();
//   const FeatureCard = ({ icon, title, desc }) => (
//     <div className="bg-white/5 border border-white/10 p-4 rounded-xl transition-all duration-300 hover:bg-white/10 cursor-default group">
//       <div className="text-white text-[22px] mb-3">{icon}</div>
//       <div className="text-lg font-semibold mb-1">{title}</div>
//       <div className="text-sm text-white/60">{desc}</div>
//     </div>
//   );

//   return (
//     <div className="h-screen flex font-sans bg-[#f7f9fb]">
//       {/* LEFT */}
//       <div
//         className="hidden lg:block w-1/2 px-12 pt-8 flex flex-col justify-between relative text-white bg-[#0078BD] overflow-hidden"
//         style={{
//           backgroundImage:
//             "radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 0)",
//           backgroundSize: "32px 32px",
//         }}
//       >
//         <div>
//           <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-5 text-xs tracking-wide uppercase font-medium">
//             <MdVerified size={18} />
//             Trusted by thousands
//           </div>

//           <h1 className="text-[40px] font-bold mb-4 leading-tight">
//             Your partner to Manage Your Properties
//           </h1>

//           <p className="text-lg opacity-70 mb-8">
//             Property management software that helps you list properties, manage tenants, collect payments and manage staff - all in one place.
//           </p>

//           <div className="grid grid-cols-2 gap-6">
//             <FeatureCard
//               icon={<LuBuilding2 />}
//               title="Manage Properties"
//               desc="Complete visibility over your entire portfolio."
//             />
//             <FeatureCard
//               icon={<FaRegSmile />}
//               title="Happy Tenants"
//               desc="Streamline communication and service requests."
//             />
//             <FeatureCard
//               icon={<FaMoneyBills />}
//               title="Track Payments"
//               desc="Automated invoicing and rent collection tracking."
//             />
//             <FeatureCard
//               icon={<MdOutlineSecurity />}
//               title="Secure & Reliable"
//               desc="Enterprise-grade security to protect your data and ensure reliability."
//             />
//           </div>
//         </div>

//         <div className="absolute bottom-0 right-0 w-[75%] h-[35%] opacity-30 mix-blend-overlay">
//           <img
//             src="/images/building.png"
//             // src="https://lh3.googleusercontent.com/aida-public/AB6AXuDdAyPYDhqr4hss3qkaspKaCQ14nfT3Y3lP7XJgqEoO-Kp15Ak-phcLq_H1HQvGjER9ZI0guNzksrL75fZVUUTUDCufizzGE0w0YKNHDHCBooMIfHsXP8YcBQmzXJwMCpCfk_7QYj9pz1NlaMMDCg0chOcYlg4Yem8KqROPeutfgwGm0tr_KJ_SppEzHctSLNg59qNbiewp2H3Bey_QPkr9tTz4CL6jl1yLRwkIX9va1vuEufdykFf4rbG-M_ghTbCas5vZDIxJ2A"
//             alt="building"
//             className="w-full h-full object-cover rounded-tl-[64px] grayscale"
//           />
//         </div>

//         {/* <div className="border-t border-white/10 pt-2 mt-2 text-sm opacity-60"> */}
//         <div className="absolute bottom-0 xl:bottom-2 2xl:bottom-4 w-full text-sm opacity-60">
//           Trusted by 5,000+ property managers across India
//         </div>
//       </div>

//       {/* RIGHT */}
//       <div className="flex-1 flex justify-center items-center p-6 relative bg-white">
//         <div className=" flex-col justify-center bg-white">
//           <LoginRight />
//         </div>
//         <div className="hidden xl:block absolute bottom-0 xl:bottom-2 2xl:bottom-4 w-full text-center text-[13px] text-[#717786]">
//           <div className="xl:mb-1 2xl:mb-3 flex justify-center gap-4 text-sm text-[#414755]">
//             <a
//               href="https://kipinn.com/terms/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="cursor-pointer hover:underline"
//             >
//               {t("Terms of Service")}
//             </a>
//             <span>•</span>
//             <a
//               href="https://kipinn.com/privacy/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="cursor-pointer hover:underline"
//             >
//               {t("Privacy Policy")}
//             </a>
//             <span>•</span>
//             {/* <span className="cursor-pointer hover:underline">{t("Help Center")}</span> */}
//             <a
//               href="https://wa.me/919958571522"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="cursor-pointer hover:underline"
//             >
//               {t("Help Center")}
//             </a>
//           </div>
//           © 2015-2026 THINKSTRAIGHT
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;